import {Injectable} from "@angular/core";
import {TimeIntervalBO} from "../../../utils/time/models/time-interval-bo";


@Injectable({
  providedIn: 'root'
})
export class TimeRepository {
  private timeIntervalBO!: TimeIntervalBO;
  private baseIntervalInMilliseconds = 15 * 60 * 1000; // 15 minutes in milliseconds
  _isInitialized: boolean = false;

  initialize(startTime: Date, endTime: Date) {
    this.timeIntervalBO = new TimeIntervalBO(startTime, endTime, this.baseIntervalInMilliseconds);
    this._isInitialized = true;
  }

  getTimeIntervalBO(): TimeIntervalBO {
    return this.timeIntervalBO;
  }

  getStartTime(): Date {
    return this.timeIntervalBO.originalStartTime;
  }

  getEndTime(): Date {
    return this.timeIntervalBO.originalEndTime;
  }

  isInitialized(): boolean {
    return this._isInitialized;
  }
}
